export const generateLocalizationSettings = () => ({
    localization: {
        defaultLanguage: '',
        isEnabled: false,
        supportedLanguages: []
    }
});
